/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_Legal_Entity_WebsiteInputs */

const cs_auth_signup_legal_entity_website = /** @type {(inputs: Auth_Signup_Legal_Entity_WebsiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web`)
};

const en_auth_signup_legal_entity_website = /** @type {(inputs: Auth_Signup_Legal_Entity_WebsiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Website`)
};

/**
* | output |
* | --- |
* | "Website" |
*
* @param {Auth_Signup_Legal_Entity_WebsiteInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_signup_legal_entity_website = /** @type {((inputs?: Auth_Signup_Legal_Entity_WebsiteInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Legal_Entity_WebsiteInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_signup_legal_entity_website(inputs)
	return cs_auth_signup_legal_entity_website(inputs)
});